import { render, staticRenderFns } from "./ArticleCategoryInfo.vue?vue&type=template&id=72ea2f8e&"
import script from "./ArticleCategoryInfo.vue?vue&type=script&lang=js&"
export * from "./ArticleCategoryInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports